import { Outlet } from "@tanstack/react-router";
const SplitComponent = Outlet;
export { SplitComponent as component };